import { ProductType } from '@/types';
import { extendPrintTypeData } from '@/model/productType/extendPrintTypeData';
import { getPrintTypes } from '@/redux/printTypes/getters/getPrintTypes';
import { Thunk } from '@/redux/types';
import { ProductTypesActionTypes, ProductTypesSetAction } from '../types';

export const setProductTypeAction =
  (productType: ProductType): Thunk<ProductType, ProductTypesSetAction> =>
  (dispatch, getState) => {
    extendPrintTypeData(productType, getPrintTypes(getState()));
    dispatch({
      type: ProductTypesActionTypes.PRODUCT_TYPE_SET,
      productType,
    });
    return productType;
  };
